// Navigation.js

import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
    <div className="container">
      <ul className="navbar-nav mx-auto"> 
        <li className="nav-item">
          <Link className="nav-link" to="/home">Home</Link> 
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/games">Games</Link> 
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/applications">Apps</Link> 
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/data-management">Data Management</Link> 
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/career">Career</Link> 
        </li>
      </ul>
    </div>
  </nav>
  );
};

export default Navigation;
